<template>
  <v-dialog v-model="show" transition="dialog-bottom-transition">
    <v-form>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Pacientes en Espera y Atendidos</v-toolbar-title>
        </v-toolbar>

        <v-card-title
          ><span
            >Este es el orden de llegada de los pacientes el día de hoy:</span
          >

          <v-spacer></v-spacer>
          <span class="label"
            ><span class="tiempo-promedio"
              >Tiempo promedio de espera del día:
              {{ promedioTiempoEspera }}
              minutos </span
            >(Sólo contabilizan aquellos turnos que ya fueron atendidos y que
            previamente se registraron como en espera)</span
          >
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" md="8" sm="4">
              <v-btn
                class="boton-filtrado"
                color="warning"
                dark
                @click="filtrarLista"
              >
                {{ textoFiltrado }}
              </v-btn>
              <v-timeline align-top dense v-if="listaTurnosFiltrados.length">
                <v-timeline-item
                  v-for="(turno, ix) in listaTurnosFiltrados"
                  :key="ix"
                  :color="getColor(turno)"
                  small
                >
                  <div class="py-4">
                    <h2 :class="`headline font-weight-light mb-4 orange--text`">
                      {{ ix + 1 }} - {{ turno.paciente }}
                      {{ turno.entreTurno ? "- (Entreturno)" : "" }}
                    </h2>
                    <div class="fecha">
                      <span>{{ formatearFecha(turno.fechaEspera) }}</span>
                      <div v-if="turno.fechaAtendido" class="line-wrapper">
                        <div class="line"></div>
                        <span class="label label__fecha"
                          >Tiempo de espera:
                          {{
                            calcularTiempoEspera(
                              turno.fechaEspera,
                              turno.fechaAtendido
                            )
                          }}
                          minutos</span
                        >
                      </div>
                      <span v-if="turno.fechaAtendido"
                        >{{ formatearFecha(turno.fechaAtendido) }}
                      </span>
                    </div>
                    <div class="hc">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            medium
                            class="mr-3"
                            color="blue"
                            v-show="
                              roles.some((o) => o.idRol === 1) ||
                              roles.some((o) => o.idRol === 4)
                            "
                            v-on="on"
                            v-bind="attrs"
                            @click.stop="historiaClinica(turno)"
                            >mdi-heart-pulse</v-icon
                          >
                        </template>
                        <span>Historia Clínica</span>
                      </v-tooltip>

                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            medium
                            class="mr-3"
                            color="indigo"
                            v-show="
                              turno.esVideoLlamada === false &&
                              $store.state.usuario.institucion
                                .utilizaLlamador &&
                              (($store.state.usuario.institucion
                                .idInstitucion === 195 &&
                                (turno.estadoTurno === 2 ||
                                  turno.estadoTurno === 3)) ||
                                ($store.state.usuario.institucion
                                  .idInstitucion !== 195 &&
                                  turno.estadoTurno == '2')) &&
                              (roles.some((o) => o.idRol === 1) ||
                                roles.some((o) => o.idRol === 4))
                            "
                            v-on="on"
                            v-bind="attrs"
                            @click.stop="llamarPaciente(turno)"
                            >mdi-bullhorn</v-icon
                          >
                        </template>
                        <span>Llamar Paciente</span>
                      </v-tooltip>
                    </div>
                  </div>
                </v-timeline-item>
              </v-timeline>
              <v-alert v-else color="purple" dark dismissible outlined>
                En éste momento no hay turnos que estén en espera.
              </v-alert>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click.stop="show = false">Salir</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import moment from "moment";
import router from "../../router/index.js";
import axios from "../../axios-auth.js";
export default {
  props: {
    visible: {
      type: Boolean,
    },
    listaTurnos: {
      type: Array,
    },
    prof: {
      type: Number,
    },
    esVistaDiaria: {
      type: Boolean,
      default: false,
    },
    dateFormatted: {
      required: true,
    },
    nombreProfesional: {
      required: true,
    },
  },
  data() {
    return {
      filtraAtendidos: true,
      roles: [],
      promedioTiempoEspera: 0,
      listaTurnosFiltrados: [],
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
    textoFiltrado() {
      return !this.filtraAtendidos
        ? "Ocultar turnos atendidos"
        : "Mostrar turnos atendidos";
    },
  },
  watch: {
    listaTurnos: {
      handler(val) {
        this.roles = this.$store.state.usuario.roles;
        this.listaTurnosFiltrados = this.filtraAtendidos
          ? [...val].filter((turno) => turno.estadoTurno !== 3)
          : [...val];
        this.calcularPromedioTiempoEspera(val);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: 2000,
      });
    },
    llamarPaciente(turno) {
      const datosLlamada = {
        nombreProfesional: this.nombreProfesional,
        idProfesional: this.prof,
        nombrePaciente: turno.paciente,
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
        fechaTurno: this.dateFormatted,
        horaTurno: turno.hora.toString().substr(0, 5),
      };
      let self = this;
      axios
        .get("/Turnos/LlamarPaciente?", {
          params: {
            nombreProfesional: datosLlamada.nombreProfesional,
            idProfesional: datosLlamada.idProfesional,
            nombrePaciente: datosLlamada.nombrePaciente,
            idInstitucion: datosLlamada.idInstitucion,
            fechaTurno: datosLlamada.fechaTurno,
            horaTurno: datosLlamada.horaTurno,
          },
        })
        .then((response) => {
          if (response.data == "Ok") {
            self.showAlert({
              icon: "success",
              title:
                "El paciente " + turno.paciente + " fue llamado correctamente",
              vm: this,
            });
          }
        })
        .catch((error) => {
          console.log("error", error);
          self.showAlert({
            icon: "error",
            title: "El paciente no pudo ser llamado",
            vm: this,
          });
        });
    },
    filtrarLista() {
      this.filtraAtendidos = !this.filtraAtendidos;
      this.listaTurnosFiltrados = this.filtraAtendidos
        ? [...this.listaTurnos].filter((turno) => turno.estadoTurno !== 3)
        : [...this.listaTurnos];
    },
    formatearFecha(fecha) {
      if (!fecha) {
        return "Sin hora de espera registrada";
      }
      return moment(fecha).format("DD/MM/YYYY - HH:mm") + "hs";
    },
    calcularTiempoEspera(espera, atendido) {
      if (!espera || !atendido) {
        return 0;
      }
      return moment(atendido).diff(moment(espera), "minutes");
    },
    calcularPromedioTiempoEspera(listaTurnos) {
      let suma = 0;
      let count = 0;

      for (const turno of listaTurnos) {
        const espera = turno.fechaEspera;
        const atendido = turno.fechaAtendido;

        if (!espera || !atendido) {
          continue; // ignora los que no tienen ambas fechas
        }

        const diff = moment(atendido).diff(moment(espera), "minutes");

        // acá diff puede ser 0, y eso sí entra al promedio
        suma += diff;
        count++;
      }

      this.promedioTiempoEspera =
        count > 0 ? parseFloat(suma / count).toFixed(2) : 0;
    },
    getColor(turno) {
      return turno.estadoTurno === 2 ? "orange" : "purple";
    },
    historiaClinica(item) {
      console.log("item", item);
      this.$store.dispatch("setDni", item.dni);
      this.$store.dispatch("setRutaSalidaHC", this.esVistaDiaria ? 1 : 3);
      this.$store.dispatch("setIndexProf", this.prof);
      if (
        ((this.$store.state.usuario.institucion.idInstitucion !== 195 &&
          item.estadoTurno != 3) ||
          item.estadoTurno == 2) &&
        !this.$store.state.usuario.institucion.esEmpresa
      ) {
        this.$swal({
          title: "Marcar como Atendido",
          text: "¿Desea marcar el turno como atendido?",
          icon: "success",
          type: "success",
          showCancelButton: true,
          background: "#ececec",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          showCloseButton: true,
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value == true) {
            axios.get("/Turnos/Atendido?", {
              params: {
                idTurno: item.idTurno,
              },
            });
          }
        });
      }
      router.push("/HistoriasClinicas");
    },
  },
};
</script>
<style lang="scss" scoped>
.fecha {
  font-size: 1rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 12px;
}
.line-wrapper {
  position: relative;
  flex: 1; /* se estira entre las fechas */
  height: 20px; /* espacio para línea + texto arriba */
}

.line {
  position: absolute;
  top: 50%; /* línea en el medio */
  left: 0;
  right: 0;
  height: 1px;
  background: currentColor;
  opacity: 0.5;
}

.tiempo-promedio {
  font-size: 1rem;
}

.label {
  font-size: 0.85rem;
  color: white;
  background-color: purple;
  padding: 0.5rem 1rem;
  border-radius: 20px;
}

.label__fecha {
  position: absolute;
  top: -40px; /* encima de la línea */
  left: 50%;
  transform: translateX(-50%);
}

.boton-filtrado {
  margin-bottom: 1rem;
  margin-top: 1rem;
  margin-left: 2.5rem;
}
.hc {
  margin-top: 1rem;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;

  button {
    &::before {
      font-size: 2.5rem;
    }
  }
}
</style>
